/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { PriorityAndStageDto, PriorityAndStageValue } from '@gh/builder-shared-data';

export type PriorityAndStage = PriorityAndStageDto;
export type PriorityAndStageItem = {
  [index: string]: any;
};

export const priorityAndStageFromDto = (dto: PriorityAndStageDto): PriorityAndStageItem[] => {
  const items: PriorityAndStageItem[] = [];

  dto.values.forEach((value: PriorityAndStageValue) => {
    const values: PriorityAndStageItem = {
      'lbl_priority': value.key,
    };
    dto.headerValues
      .forEach((headerValue: string, index: number) => values[headerValue] = value.values[index]);

    items.push(values);
  });

  return items;
};
